import { Component, Input, OnInit, inject } from '@angular/core';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AppService } from '../app.service';
import { ApplicationService } from '../application/application.service';
import { ConnectionDB } from '../interfaces/connectionDb';
import { Controller } from '../interfaces/controller';
import { ImportFileCsvCreate } from '../interfaces/importFileCsvCreate';
import { MatStepLabel } from '@angular/material/stepper';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatDialogContent } from '@angular/material/dialog';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { ScrollbarModule, IconModule } from '@michelin/theme';
import { MatOption } from '@angular/material/autocomplete';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'mic-app-formulaire',
  templateUrl: './formulaire.component.html',
  styleUrls: ['./formulaire.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatStepLabel,
    CdkScrollable,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    MatSelect,
    ScrollbarModule,
    MatOption,
    MatCheckbox,
    MatTooltip,
    IconModule
  ]
})
export class FormulaireComponent implements OnInit {
  private readonly appService = inject(AppService);
  private readonly applicationService = inject(ApplicationService);

  @Input() data: any;
  sheetNumber = [0];
  connectionDB: ConnectionDB[] = [];
  controllers: Controller[] = [];

  ngOnInit(): void {
    this.applicationService.getApplication().subscribe((response) => {
      this.connectionDB = response.connectionDBS;
      this.controllers = response.controllers;
    });
  }
  step2 = new FormGroup({
    name: new FormControl(null),
    targetName: new FormControl(null),
    connectionDBId: new FormControl(null),
    header: new FormControl(true),
    append: new FormControl(true),
    delimiter: new FormControl(';'),
    columnCsvList: new FormArray([
      new FormGroup({
        name: new FormControl(null),
        controllerId: new FormControl(null),
        nullable: new FormControl(true)
      })
    ])
  });
  onAddColumn() {
    const group = new FormGroup({
      name: new FormControl(null),
      controllerId: new FormControl(null),
      nullable: new FormControl(true)
    });
    (this.step2.get('columnCsvList') as FormArray).push(group);
  }
  onDeleteColumn(i: any) {
    (this.step2.get('columnCsvList') as FormArray).removeAt(i);
    (this.step2.get('columnCsvList') as FormArray).markAsDirty();
  }
  addSheet() {
    this.appService.sheets.next(this.step2.value as ImportFileCsvCreate);
    this.sheetNumber.push(this.sheetNumber[this.sheetNumber.length - 1] + 1);
  }
  onSubmit() {
    // this.appService.sheets.next(this.step2.value);
  }
  get controls() {
    return (this.step2.get('columnCsvList') as FormArray).controls;
  }
}
